angular.
module("dx.webapp.integrations").
constant("DX_SAML_INTEGRATION_TYPE", Object.freeze({
	SKOLFEDERATION: "skolfederation",
	OTHER: "other",
}));
